import { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import DepartingPobListItem from './departing-item';
import { DragDropCtx } from 'context/drag-drop-provider';
import { getDomNodeRef } from 'common/util-ts';
import { PobListSelectionProps } from '../pob-list-selection';

export interface DepartingPobListProps extends PobListSelectionProps {
	data: any[];
}

const DepartingPobList: React.FC<DepartingPobListProps> = (props) => {
	const dragState = useContext(DragDropCtx);

	let isDisabled = dragState?.source?.droppableId !== 'onboard';

	return (
		<Droppable
			droppableId='departing'
			mode='virtual'
			isDropDisabled={isDisabled}
			renderClone={(provided, snapshot, rubric) => (
				<DepartingPobListItem
					key={props.data[rubric.source.index]?._id}
					pobObj={props.data[rubric.source.index]}
					provided={provided}
					className='mc-quartermaster-pob-card mc-quartermaster-pob-card-dragging'
				/>
			)}
		>
			{(provided, snapshot) => {
				return (
					<AutoSizer>
						{({ height, width }) => (
							// TODO: Fix virtual list cutting off last pob item when dragging something into it
							<VirtualizedList
								style={{ marginTop: 1 }}
								height={height}
								width={width}
								rowHeight={46}
								rowCount={props.data.length}
								ref={getDomNodeRef(provided.innerRef)}
								rowRenderer={({ index, style }) => {
									if (!props.data[index]) {
										console.error(
											'PobNode object at index ' + index + ' is NULL'
										);
									}
									return (
										<Draggable
											key={props.data[index]?._id}
											draggableId={props.data[index]?._id}
											index={index}
											// Drag-and-drop feature is temporarily disabled.
											isDragDisabled
										>
											{(provided) => (
												<DepartingPobListItem
													pobObj={props.data[index]}
													style={style}
													provided={provided}
													className='mc-quartermaster-pob-card'
													selectionEnabled={props.selectionEnabled}
													selected={props.selectedPobIds.includes(
														props.data[index]?._id
													)}
													onSelectedChange={() =>
														props.onPobSelectionChange(
															props.section,
															props.data[index]?._id
														)
													}
												/>
											)}
										</Draggable>
									);
								}}
							/>
						)}
					</AutoSizer>
				);
			}}
		</Droppable>
	);
};

export default DepartingPobList;
